import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import DevelopmentActions from "data/dev/DevelopmentActions";
import typeCheckingStore from "data/util/typeCheckingStore";

class ITTestStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {
            case DevelopmentActions.SELECT_IT_TEST:
                return {
                    path: action.path,
                    script: action.script,
                };
            case DevelopmentActions.AD_HOC_IT_TEST:
                return {
                    path: null,
                    script: action.script,
                };
            case DevelopmentActions.IT_TEST_ERROR:
                return {
                    ...state,
                    success: false,
                    message: action.message,
                };
            case DevelopmentActions.IT_TEST_SUCCESS:
                if (state.success != null) return state;
                return {
                    ...state,
                    success: true,
                };
            default:
                return state;
        }
    }

}

ITTestStore.stateTypes = {
    path: PropTypes.string,
    script: PropTypes.string,
};

export default typeCheckingStore(new ITTestStore());



// WEBPACK FOOTER //
// ./app/data/dev/ITTestStore.js